const appearanceAnimation = (
  direction: "top" | "bottom" | "left" | "right"
) => {
  switch (direction) {
    case "top":
      return {
        initial: { opacity: 0, y: -50 },
        whileInView: { opacity: 1, y: 0 },
        viewport: { once: true, margin: "-5px" },
        transition: { duration: 0.6, ease: "easeOut" }
      };

    case "bottom":
      return {
        initial: { opacity: 0, y: 50 },
        whileInView: { opacity: 1, y: 0 },
        viewport: { once: true, margin: "-5px" },
        transition: { duration: 0.6, ease: "easeOut" }
      };

    case "left":
      return {
        initial: { opacity: 0, x: -50 },
        whileInView: { opacity: 1, x: 0 },
        viewport: { once: true, margin: "-5px" },
        transition: { duration: 0.6, ease: "easeOut" }
      };

    case "right":
      return {
        initial: { opacity: 0, x: 50 },
        whileInView: { opacity: 1, x: 0 },
        viewport: { once: true, margin: "-5px" },
        transition: { duration: 0.6, ease: "easeOut" }
      };
  }
};

const flyUpAnimation = (index: number) => {
  return {
    initial: { opacity: 0, y: 50 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, margin: "-100px" },
    transition: { duration: 0.6, ease: "easeOut", delay: index * 0.2 }
  };
};

const rotateAnimation = (index: number) => {
  return {
    initial: { opacity: 0, rotateY: 90 },
    whileInView: { opacity: 1, rotateY: 0 },
    viewport: { once: true, margin: "-50px" },
    transition: { duration: 0.9, ease: "easeOut", delay: index * 0.2 }
  };
};

const bounceAnimation = (index: number) => {
  return {
    initial: { opacity: 0, scale: 0.8 },
    whileInView: { opacity: 1, scale: 1 },
    viewport: { once: true, margin: "-50px" },
    transition: {
      duration: 0.7,
      ease: "easeOut",
      type: "spring",
      stiffness: 120,
      delay: index * 0.25
    }
  };
};

const slideLeftAnimation = (index: number) => {
  return {
    initial: { opacity: 0, x: -100 },
    whileInView: { opacity: 1, x: 0 },
    viewport: { once: true, margin: "-50px" },
    transition: { duration: 0.6, ease: "easeOut", delay: index * 0.2 }
  };
};

const zoomInAnimation = (index: number) => {
  return {
    initial: { opacity: 0, scale: 0.5 },
    whileInView: { opacity: 1, scale: 1 },
    viewport: { once: true, margin: "-50px" },
    transition: { duration: 0.8, ease: "easeInOut", delay: index * 0.15 }
  };
};

export {
  appearanceAnimation,
  flyUpAnimation,
  rotateAnimation,
  bounceAnimation,
  slideLeftAnimation,
  zoomInAnimation
};
